import { AiOutlineArrowRight } from "react-icons/ai";
import "./Hero.css";

import Slider from "react-slick";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowR } from "../../assets/images/IZB/arrow_right.svg";

import HeroSlide1 from "./HeroSlide1";
import HeroSlide2 from "./HeroSlide2";
import HeroSlide3 from "./HeroSlide3";
import HeroSlide4 from "./HeroSlide4";
import HeroSlide5 from "./HeroSlide5";
import HeroSlide6 from "./HeroSlide6";
import HeroSlide7 from "./HeroSlide7";

const Hero = () => {

  const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
  const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";
  const SavingAcc = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Credit.svg";
  const Credit = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 656.svg";

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowLeft}
        className={className}
        style={{
          ...style,
          display: "block",
          width: "50px",
          height: "50px",
          left: "40px",
          zIndex: 1,
        }}
        onClick={onClick}
      />
    );
  }
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowRight}
        className={className}
        style={{
          ...style,
          display: "block",
          width: "50px",
          height: "50px",
          right: "40px",
        }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 9000,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
 
  };

  const textColor = {
    color: "#9E1B1E",
  };

  return (
    <>
      <section className="homepage-first-section">
        <section className="position-relative homepage-herobanner">
          <Slider {...settings}>
            {/* <div>
              <HeroSlide1 />
            </div> */}
            {/* <div>
              <HeroSlide2 />
            </div> */}
            <div>
              <HeroSlide6 />
            </div>
            <div>
              <HeroSlide3 />
            </div>
            <div>
              <HeroSlide4 />
            </div> 
            <div>
              <HeroSlide5 />
            </div>
            {/* <div>
              <HeroSlide7 />
            </div> */}
          </Slider>
        <section
        
        className="documents-area col-sm-10 col-md-10 col-lg-10 col-xl-10 shadow p-0 p-md-3 me-3"
      
      >
        <div className="container py-3">
          <div className="row">
            <div className="col-xl-6 col-lg-6 px-0 px-md-3">
              {/*Start Single Documents Box*/}
              <div
                className="single-documents-box p-0"
                style={{ borderRadius: "12px" }}
              >
                <div className="features-style2-tab-content-box-item">
                  <div className="row">

                    <div className="col-xl-12 col-md-12 p-0">
                      <div
                        className="features-style2-text-box text-center p-2 mx-1 mb-0 text-white heading-box"
                        style={{ borderRadius: "13px 13px 0 0" }}
                      >
                        <Link to="/PersonalBanking">
                          <h4 className="text-white" style={textColor}>
                            Personal Banking
                          </h4>
                          <AiOutlineArrowRight
                            size={20}
                            className="ms-2 text-white position-absolute"
                            style={{ top: "32%", right: "2%" }}
                          />
                        </Link>
                      </div>
                    </div>

                    <div className="custom-flex">
                      <div className="custom-flex_first">
                        <div className="features d-flex flex-column align-items-center">
                          <div className="text-box d-flex flex-column align-items-center">
                            <img
                              className="pt-3"
                              width={70}
                              src={SavingAcc}
                              alt="Saving Account"
                            />
                            <h5
                              className="text-center pt-3 MenuTitle"
                              style={textColor}
                            >
                              Saving Account
                            </h5>
                          </div>
                          <div className="pt-3 BankMenuLinks">
                            <div >
                              <Link
                                to="/SavePlusAccount "
                                style={textColor}
                              >
                                <ArrowR />
                                Save Plus Account
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/PrivilageSavingAcc "
                                style={textColor}
                              >
                                <ArrowR />
                                Privilege Savings Account
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/TisungoSaving "
                                style={textColor}
                              >
                                <ArrowR />
                                Tisunge Savings Account
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className="border"></span>
                      <div className="custom-flex_second">
                        <div
                          className="features d-flex flex-column align-items-center"
                          style={{ borderRadius: "12px" }}
                        >
                          <div className="text-box d-flex flex-column align-items-center">
                            <img
                              className="pt-3"
                              width={70}
                              src={Credit}
                              alt="Saving Account"
                            />
                            <h5 className="text-center pt-3 MenuTitle" style={textColor}>
                              Credit
                            </h5>
                          </div>
                          <div className="py-3 BankMenuLinks">
                            <div>
                              <Link
                                to="/IndoPersonalLoan "
                                style={textColor}
                              >
                                <ArrowR />
                                Personal Loan
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/IndoHomeLoan "
                                style={textColor}
                              >
                                <ArrowR />
                                Indo Home Loan
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/IndoVehicleLoan "
                                style={textColor}
                              >
                                <ArrowR />
                              Indo Vehicle Loan
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
                <span className="Hborder"></span>
                <div className="d-flex align-items-center justify-content-end p-2">
                  <Link to="/PersonalBanking" style={textColor}>
                    Read More
                    <AiOutlineArrowRight className="ms-2" />
                  </Link>
                </div>
              </div>
              {/*End Single Documents Box*/}
            </div>

            <div className="col-xl-6 col-lg-6 px-0 px-md-3">
              {/*Start Single Documents Box*/}
              <div
                className="single-documents-box p-0 rounded-4 "
                style={{ borderRadius: "12px" }}
              >
                <div className="features-style2-tab-content-box-item">
                  <div className="row">

                    <div className="col-xl-12 col-md-12 p-0">
                      <div
                        className="features-style2-text-box text-center p-2 mx-1 mb-0 text-white heading-box"
                        style={{ borderRadius: "13px 13px 0 0" }}
                      >
                        <Link to="/BusinessBanking">
                          <h4 className="text-white " style={textColor}>
                            Business Banking
                          </h4>
                          <AiOutlineArrowRight
                            size={20}
                            className="ms-2 text-white position-absolute"
                            style={{ top: "32%", right: "2%" }}
                          />
                        </Link>
                      </div>
                    </div>

                    <div className="custom-flex second-div">
                      <div className="custom-flex_first">
                        <div className="features d-flex flex-column align-items-center">
                          <div className="text-box d-flex flex-column align-items-center">
                            <img
                              className="pt-3"
                              width={70}
                              src={SavingAcc}
                              alt="Saving Account"
                            />
                            <h5 className="text-center pt-3 MenuTitle" style={textColor}>
                              Current Account
                            </h5>
                          </div>
                          <div className="pt-3 BankMenuLinks">
                            <div className="">
                              <Link
                                to="/PrivilegeCurrentAcc "
                                className=""
                                style={textColor}
                              >
                                <ArrowR />
                                Privilege Current Account
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/ClassicCurrentAccount "
                                className=""
                                style={textColor}
                              >
                                <ArrowR />
                                Classic Current Account
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/SMECurrentAcc "
                                className=""
                                style={textColor}
                              >
                                <ArrowR />
                                SME Current Account
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span className="border"></span>
                      <div className="custom-flex_second">
                        <div className="features d-flex flex-column align-items-center">
                          <div className="text-box d-flex flex-column align-items-center">
                            <img
                              className="pt-3"
                              width={70}
                              src={Credit}
                              alt="Saving Account"
                            />
                            <h5 className="text-center pt-3 MenuTitle" style={textColor}>
                              Credit
                            </h5>
                          </div>
                          <div className="py-3 BankMenuLinks ">
                            <div className="">
                              <Link
                                to="/TermLoan"
                                className=""
                                style={textColor}
                              >
                                <ArrowR />
                                Term Loan
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/AutoFinance"
                                className=""
                                style={textColor}
                              >
                                <ArrowR />
                                Auto Finance
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="/AgroFinance"
                                className=""
                                style={textColor}
                              >
                                <ArrowR />
                                Argo Finance
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <span className="Hborder"></span>
                <div className="d-flex align-items-center justify-content-end p-2">
                  <Link to="/BusinessBanking" style={textColor}>
                    Read More
                    <AiOutlineArrowRight className="ms-2" />
                  </Link>
                </div>
              </div>
              {/*End Single Documents Box*/}
            </div>

          </div>
        </div>
      </section>
        </section>
       
      </section>
    </>
  );
};

export default Hero;
